import React from "react";
import { SkeletonLoader, SkeletonUnit } from "../../../../components/SkeletonLoader";
import { Accordion } from "../../../Accordion";
import * as S from "../styles";
import { size } from "./../../../../shared/constants";

var byTag = function byTag(e) {
  return function (_ref) {
    var t = _ref.tags;
    return t.includes(e);
  };
},
    MenuContainer = function MenuContainer(_ref2) {
  var e = _ref2.values,
      t = _ref2.drawerRef,
      a = _ref2.setOpen,
      l = _ref2.topLevelLinks,
      n = _ref2.handleLinkClick,
      r = _ref2.productCategories,
      i = _ref2.combinedProducts,
      o = _ref2.loggedIn,
      c = _ref2.isLoggingIn,
      s = _ref2.accountLinks,
      u = _ref2.membership,
      m = _ref2.learnCategories,
      d = _ref2.forBusinessesCategories,
      b = _ref2.membershipLink,
      p = _ref2.membershipSubText,
      g = _ref2.onLogout;
  return React.createElement(S.MenuContainer, {
    style: e,
    ref: t,
    "data-testid": "mobile-menu-container"
  }, React.createElement(S.CloseButtonWrapper, {
    "data-testid": "mobile-menu-close-button",
    onClick: function onClick() {
      return a(!1);
    }
  }, React.createElement(S.CloseIcon, null)), React.createElement(S.MenuTop, null, l.shopAll ? React.createElement(S.MenuItem, {
    key: "shop-all",
    href: l.shopAll.url,
    "data-testid": "mobile-shop-all-link",
    onClick: function onClick() {
      var e;
      return l && l.shopAll && l.shopAll.label && n(null === (e = null == l ? void 0 : l.shopAll) || void 0 === e ? void 0 : e.label);
    }
  }, l.shopAll.label) : null, React.createElement(Accordion.Wrapper, null, r.map(function (e) {
    return React.createElement(S.AccordionItem, {
      key: e.slug
    }, React.createElement(S.AccordionHeading, {
      dataTestId: "mobile-shop-category-" + e.slug,
      onClick: function onClick() {
        return n(e.displayName);
      }
    }, e.displayName), i.filter((t = e.slug, function (_ref3) {
      var e = _ref3.tags;
      return e.includes(t);
    })).map(function (_ref4, r) {
      var t = _ref4.label,
          a = _ref4.url,
          l = _ref4.slug;
      return React.createElement(S.AccordionChild, {
        key: "".concat(l, "-").concat(r)
      }, React.createElement(S.MenuItem, {
        "data-testid": l,
        onClick: function onClick() {
          return n("".concat(e.displayName, " - ").concat(t));
        },
        href: a
      }, t));
    }));
    var t;
  }))), React.createElement(S.MenuMiddle, null, !0 === c ? React.createElement(SkeletonLoader, {
    height: {
      value: Number(size.xl3),
      unit: SkeletonUnit.Pixel
    },
    width: {
      value: 100,
      unit: SkeletonUnit.Percentage
    },
    testId: "skeleton-loader"
  }) : React.createElement(React.Fragment, null, l.register ? React.createElement(S.Button, {
    href: l.register.url,
    appearance: "secondary",
    "data-testid": "mobile-register-link"
  }, l.register.label) : null, o ? null : s.login ? React.createElement(S.Button, {
    href: s.login.url,
    appearance: "secondary",
    "data-testid": "mobile-login-link"
  }, s.login.label) : null)), React.createElement(S.MenuBottom, null, l.learn ? React.createElement(S.LinkCategory, null, React.createElement(S.LinkCategoryHeading, {
    "data-testid": "mobile-learn-heading"
  }, l.learn.label), Object.keys(m).map(function (e, t) {
    return React.createElement(S.MenuItem, {
      href: m[e].url,
      "data-testid": "mobile-learn-link-" + t,
      key: e
    }, e);
  })) : null, l.business ? React.createElement(S.LinkCategory, null, React.createElement(S.LinkCategoryHeading, {
    "data-testid": "mobile-business-heading"
  }, l.business.label), Object.keys(d).map(function (e, t) {
    return React.createElement(S.MenuItem, {
      href: d[e].url,
      "data-testid": "mobile-business-link-" + t,
      key: e
    }, e);
  })) : null, l.support ? React.createElement(S.LinkCategory, null, React.createElement(S.LinkCategoryHeading, {
    "data-testid": "mobile-support-heading"
  }, l.support.label), React.createElement(S.MenuItem, {
    href: l.support.url,
    "data-testid": "mobile-support-link"
  }, l.support.mobileSubcategoryLabel)) : null, o ? React.createElement(S.LinkCategory, null, React.createElement(S.LinkCategoryHeading, {
    "data-testid": "mobile-account-heading"
  }, s.account.label), u ? React.createElement(S.MenuItem, {
    href: b(u),
    "data-testid": "mobile-membership-account-link",
    "data-analytics-event": "Clicked Button",
    "data-analytics-label": "membership-account-link",
    "data-analytics-category": u.creditsAvailable > 0 ? "has-credits" : "no-credits"
  }, s.account.membership.label, "!", React.createElement(S.MenuItemSubText, {
    "data-testid": "mobile-membership-account-text"
  }, p(u))) : null, React.createElement(S.MenuItem, {
    href: s.account.results.url,
    "data-testid": "mobile-results-link"
  }, s.account.results.label), React.createElement(S.MenuItem, {
    href: s.account.settings.url,
    "data-testid": "mobile-settings-link"
  }, s.account.settings.label), React.createElement(S.MenuItem, {
    href: s.account.logout.url,
    "data-testid": "mobile-logout-link",
    onClick: g
  }, s.account.logout.label)) : null));
};

export default MenuContainer;